import {Avatar, Box, IconButton, Stack, Typography} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

export function renderUserAvatar(row) {
    return <Avatar sx={{height: 40, width: 40, marginRight: '20px'}} alt=' ' src={row.profile_picture}/>;
}

export const StatusActiveIcon = () => {
    return (
        <Stack direction={'row'} display={'flex'} alignItems={'center'} gap={1}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                <circle cx="4.5" cy="4.5" r="4.5" fill="url(#paint0_linear_2025_1756)"/>
                <defs>
                    <linearGradient id="paint0_linear_2025_1756" x1="4.5" y1="0" x2="4.5" y2="9" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#009621"/>
                        <stop offset="1" stopColor="#21CB46"/>
                    </linearGradient>
                </defs>
            </svg>
            <Typography>Active</Typography>
        </Stack>
    )
}
export const StatusDeActiveIcon = () => {
    return (
        <Stack direction={'row'} display={'flex'} alignItems={'center'} gap={1}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                <circle opacity="0.5" cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/>
            </svg>
            <Typography>Inactive</Typography>
        </Stack>
    )
}

export function renderUserActiveStatus(row) {
    const isActive = row?.is_active === true || row?.is_active === 'True';
    return <Typography sx={{color: '#FFFFFF', fontSize: 14}} component="div">
        {isActive ? <StatusActiveIcon/> : <StatusDeActiveIcon/>}
    </Typography>;
}

export function renderUserActions(row, handleActiveToggle, handleEdit, handleDelete, editDeleteIsDisabled) {
    const isActive = row?.is_active === true || row?.is_active === 'True';

    const blockSx = editDeleteIsDisabled ? {pointerEvents: 'none', opacity: 0.5} : {};
    const base = editDeleteIsDisabled ? '#888888' : '#FFFFFF';
    const hover = editDeleteIsDisabled ? '#888888' : '#FFC540';

    const itemSx = {display: 'flex', flexDirection: 'column', alignItems: 'center'};

    return (
        <>
            {handleActiveToggle && (
                <Box sx={itemSx}>
                    <IconButton onClick={() => handleActiveToggle(row)}>
                        <PowerSettingsNewIcon sx={{color: '#FFFFFF', '&:hover': {color: '#FFC540'}}}/>
                    </IconButton>
                    <Typography sx={{color: '#FFFFFF', fontSize: 14}}>
                        {isActive ? 'Deactivate' : 'Activate'}
                    </Typography>
                </Box>
            )}
            {handleEdit && (
                <Box sx={itemSx}>
                    <IconButton onClick={() => handleEdit(row)} aria-disabled={editDeleteIsDisabled} disabled={editDeleteIsDisabled} sx={blockSx} aria-label="edit-user">
                        <EditOutlinedIcon sx={{color: base, '&:hover': {color: hover}}}/>
                    </IconButton>
                    <Typography sx={{color: '#FFFFFF', fontSize: 14}}>Edit</Typography>
                </Box>
            )}
            {handleDelete && (
                <Box sx={itemSx}>
                    <IconButton onClick={() => handleDelete(row)} aria-disabled={editDeleteIsDisabled} disabled={editDeleteIsDisabled} sx={blockSx} aria-label="delete-user">
                        <DeleteIcon sx={{color: base, '&:hover': {color: hover}}}/>
                    </IconButton>
                    <Typography sx={{color: '#FFFFFF', fontSize: 14}}>Delete</Typography>
                </Box>
            )}
        </>
    );
}